import styled from 'styled-jss'

export const theme = {
  colors: {
    orange: '#f04e23',
    orangeDark: '#db3b0f',
    white: '#FFFFFF',
    navy: '#46555F',
  },
  fonts: {
    univers: '"Univers LT Std 65", sans-serif',
  },
}

const flexBox = (alignItems = 'center') => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: alignItems,
  }
}
export const StyledStrategyBlock = styled('div')({
  padding: [20, 45, 15],
  background: '#FDFDFD',
  border: `1px solid ${theme.colors.white}`,
  boxShadow: '0 0 5px rgba(0, 0, 0, 0.17)',
  width: '100%',
  ...flexBox('space-between'),
  position: 'relative',
  '@media (max-width: 576px)': {
    padding: [30, 30, 15],
  },
  '&:nth-child(2n)': {
    margin: [60, 0],
  },

  '&:last-of-type h2 a': {
    fontSize: 30,
  }
})

export const Title = styled('h2')({
  fontSize: '2em',
  lineHeight: '1.8em',
  marginBottom: '0!important',
  '&:before': {
    left: -2,
    top: 22,
    width: 8,
    height: 60,
    content: '""',
    position: 'absolute',
    backgroundColor: theme.colors.orange,
  },
  '& > a': {
    fontFamily: theme.fonts.univers,
    fontWeight: 400,
    textDecoration: 'none',
    color: theme.colors.orange,
  },
  '@media (max-width: 576px)': {
    margin: [0, 0, 40],
    lineHeight: '1.5em',
  },
})

export const StrategyDescription = styled('p')({
  fontFamily: theme.fonts.univers,
  color: '#46555F',
  fontWeight: 400,
  fontStyle: 'italic',
  fontSize: '18px',
  marginTop: '0.6em',
})

export const InfoBox = styled('div')({
  maxWidth: 110,
  height: 'max-content',
  minHeight: 88,
  padding: 10,
  boxSizing: 'border-box',
  ...flexBox(),
  background: '#F8F8F8',
  '@media (max-width: 992px)': {
    padding: 5,
    margin: 2,
    maxWidth: 85,
  },
  '@media (max-width: 360px)': {
    maxWidth: 79,
  },
  '& > span': {
    color: theme.colors.navy,
    textAlign: 'center',
    fontFamily: 'Chaparral Pro',
    display: 'inline-block',
    width: '100%',
    '&.title': {
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: 15,
    },
    '&.value': {
      fontWeight: 500,
      fontSize: '1.4em',
    },
  },
})

export const Column = styled('div')({
  ...flexBox('space-between'),

  width: (props) => props.colWidth || '100%',
  '@media (max-width: 992px)': {
    width: '50%!important',
  },
  '@media (max-width: 576px)': {
    width: '100%!important',
  },
})

export const ViewButton = styled('a')({
  fontFamily: theme.fonts.univers,
  fontWeight: 400,
  fontSize: '1.4em',
  color: theme.colors.orangeDark,
  textDecoration: 'none',
  width: '100%',
  textAlign: 'center',
  paddingLeft: 40,
  marginBottom: 60,

  '@media (max-width: 992px)': {
    paddingLeft: 0,
    textAlign: 'left',
    marginBottom: 0,
  },
  '@media (max-width: 576px)': {
    padding: [25, 0, 10],
    textAlign: 'center',
  },

  '& > svg': {
    marginLeft: 10,
  },
  '&:hover': {
    color: theme.colors.orangeDark,
    fontWeight: 500
  },
})

export const Spinner = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60px',
  height: '60px',

  '& > div': {
    borderRadius: '50%',
    animation: 'initialLoader 0.7s linear infinite',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 60,
    height: 60,
    border: `6px solid ${theme.colors.orange}`,
    borderRightColor: '#F8F8F8',
  },
})
